// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EOdcM","col":"styles_col__2K93K"};